<template>
  <div>
    <label class="label">นัดหมายวัน</label>
    <div class="input appointment-date-constraint">
      <div
        v-for="appointDateConstraint in appointDateConstraints"
        :key="appointDateConstraint.slotNumber"
        class="d-flex flex-row slot"
      >
        <p class="mr-5">ครั้งที่ {{ appointDateConstraint.slotNumber }}</p>
        <div v-if="appointDateConstraint.slotNumber == 1">
          <p>วันที่ลูกค้านัดหมายครั้งแรก</p>
        </div>
        <div v-else class="d-flex flex-row">
          <p>ห่างจากครั้งที่ {{ appointDateConstraint.slotNumber - 1 }}</p>
          <el-input
            v-model="appointDateConstraint.constraints"
            class="date-constraint"
            type="number"
          >
          </el-input>
          <p>วัน</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Radio } from "element-ui";
export default {
  props: ["value"],
  components: {
    "el-input": Input,
    "el-radio": Radio
  },
  computed: {
    appointDateConstraints() {
      return this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.input {
  margin-bottom: 20px;

  .date-constraint {
    width: 80px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.appointment-date-constraint {
  height: auto;
  width: 25%;
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: $border-radius;

  .slot {
    width: 100%;
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/components/ServiceAppointmentDateConstraintEditor.vue